export default __webpack_public_path__ + "static/media/misc-makeupA-1024w.691320f6.png";